export const bioscopeAlertCodes: string[] = [
    'noMeasurements1d',
    'noMeasurements2h',
    'badAngle',
    'visibility_rope',
    'visibility_dew',
    'humidity',
    'depthMissing',
    'bigVerticalDisparity',
    'bioscopeMoveFailed',
    //Not fixable by user:
    'visibility_net',
    'calibrationAge',
    'weightDistance',
    'bioscopeMoveTakingTooLong',
    'depthTooShallow',
    'depthTooDeep',
    'ledIntensity',
    'fewMeas',
    'uptime',
];

export const isUserActionRequired = (alertCode: string): boolean => {
    return bioscopeAlertCodes.indexOf(alertCode) < bioscopeAlertCodes.indexOf('visibility_net');
};
